import { EXTENSION_TUNNEL_ORIGIN } from "common/constants";

type ChromeExtensionResponse<ResponseData> =
  | { status: "ok"; response: ResponseData }
  | { status: "error"; error: string }
  | undefined;

export default function useChromeExtension() {
  async function sendExtensionMessage<ResponseData>(
    command: "ping" | "getCookies",
    extensionId: string,
  ) {
    return new Promise<ChromeExtensionResponse<ResponseData>>(
      (resolve, reject) => {
        if (extensionId) {
          if (!window.chrome?.runtime) {
            throw new Error("chrome.runtime not found");
          }
          window.chrome.runtime.sendMessage(
            extensionId,
            { command },
            (response) => {
              resolve(response);
            },
          );
        } else {
          const extensionTunnelIframe = document.getElementById(
            "extension-tunnel",
          ) as HTMLIFrameElement;

          if (!extensionTunnelIframe) {
            reject("Extension tunnel not found");
          }
          const timeoutId = setTimeout(() => {
            reject("Request to extension tunnel timed out");
          }, 2000);

          function onMessage(event: MessageEvent) {
            if (event.source === extensionTunnelIframe.contentWindow) {
              const response = event.data ? JSON.parse(event.data) : undefined;
              resolve(response);
              clearTimeout(timeoutId);
              window.removeEventListener("message", onMessage);
            }
          }
          window.addEventListener("message", onMessage);

          extensionTunnelIframe.contentWindow.postMessage(
            JSON.stringify({
              command,
              authToken: localStorage.getItem("auth"),
            }),
            EXTENSION_TUNNEL_ORIGIN,
          );
        }
      },
    );
  }

  async function pingExtension(extensionId: string) {
    return sendExtensionMessage<{ name: string }>("ping", extensionId);
  }

  async function getExtensionCookies(extensionId: string) {
    return sendExtensionMessage<object[]>("getCookies", extensionId);
  }

  return {
    pingExtension,
    getExtensionCookies,
  };
}
